import { ModalVideo } from './ModalVideo';

export type { TypeModalVideoProps } from './types';
export default ModalVideo;
